import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './Works.css';
import cs from '../../commonStyle.css';
class Works extends Component {
  static propTypes = {
    formatMessage: PropTypes.any,
    refer: PropTypes.string,
    siteName: PropTypes.string.isRequired
  };

  render() {
    const { data } = this.props
    return (
      <div className={s.workSection}>
        <div className={s.container}>
          <div className={cs.textAlignCenter}>
            <h2 className={s.workTitle}>{data && data.workTitleHeading}</h2>
          </div>
          <Row className={cx(cs.dFlex, s.flexWrap)}>
            <Col lg={5} md={5} sm={5} xs={12}>
              <div className={s.getStartedImage}>
                <img src={'/images/home/' + data.workImage4} className={cs.fullWidth} />
              </div>
            </Col>
            <Col lg={7} md={7} sm={7} xs={12}>
              <div className={s.workList}>
                <div className={s.workListItem}>
                  <div className={s.workListItemNumber}>1</div>
                  <div className={s.workListItemContent}>
                    <h3>{data && data.peaceTitle1}</h3>
                    <p>{data && data.peaceContent1}</p>
                  </div>
                </div>
                <div className={s.workListItem}>
                  <div className={s.workListItemNumber}>2</div>
                  <div className={s.workListItemContent}>
                    <h3>{data && data.peaceTitle2}</h3>
                    <p>{data && data.peaceContent2}</p>
                  </div>
                </div>
                <div className={s.workListItem}>
                  <div className={s.workListItemNumber}>3</div>
                  <div className={s.workListItemContent}>
                    <h3>{data && data.peaceTitle3}</h3>
                    <p>{data && data.peaceContent3}</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withStyles(s, cs)(Works);
